import { ISessionLocation, ISessionTenant, ISessionUser, ISessionHomePage, ISessionUserContext, ISessionApplication } from 'app/shared/lib/session/session-types';

export const emptyHomePage: ISessionHomePage = {

    id: '',
    code: '',
    description: '',
    href: ''

};

export const emptyApplication: ISessionApplication = {
    id: '',
    code: ''
};

export const emptyTenant: ISessionTenant = {

    isSelected: false,

    id: '',
    code: '',
    description: '',

    timeZone: '',
    language: '',
    twoFactorEnabled: false,
    twoFactorPersist: false,

    locations: [],
    userContexts: []

};

export const emptyUser: ISessionUser = {

    isLoggedIn: false,
    hasGlobalAccess: false,

    id: '',
    loginName: '',
    description: '',

    name: {
        first: '',
        middle: '',
        last: '',
        full: '',
        display: ''
    },

    emailAddress: '',
    title: '',
    department: '',

    timeZone: '',
    language: '',

    homePage: emptyHomePage,

    signOnProvider: null

};

export const emptyUserContext: ISessionUserContext = {

    isSelected: false,

    id: '',
    description: '',
    attachedToCode: '',
    attachedToId: ''

};

export const emptyLocation: ISessionLocation = {

    isSelected: false,

    id: '',
    code: '',
    description: ''

};
